module.exports = __webpack_public_path__ + "static/media/steren.b67c0458.png";